import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../redux/auth/authSlice';
import PhoneStep from './PhoneStep';
import OtpStep from './OtpStep';
import styles from './styles.module.css';

const ProfileCompletion = () => {
  const user = useSelector(selectCurrentUser);
  const [phase, setPhase] = useState('phone'); // 'phone' | 'otp'
  const [phone, setPhone] = useState('');

  if (!user) return null;

  return (
    <div className={styles.pc_container}>
      {phase === 'phone' && <PhoneStep userId={user.id || user._id} onSuccess={(p)=>{ setPhone(p); setPhase('otp'); }} />}
      {phase === 'otp' && <OtpStep userId={user.id || user._id} phone={phone} />}
    </div>
  );
};
export default ProfileCompletion;
